module.exports = __webpack_public_path__ + "assets/img/98@3x.eaccf56c.png";